import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './CapboxAssessmentResult.styles';

const CapBoxAssessmentResult = ({
    findings
}) => {
    const { t } = useTranslation();
    const changeSeverityKey = (value) => {
        if (value === 'N/A') return 'n_a';
        if (value === 'Zero Tolerance') return 'zero_tolerance';
        return value.toLowerCase();
    }
    const severityCounts = Object.entries(findings.reduce((_item, { info }) => {
        const item = { ..._item };
        item[info.criticality] = (item[info.criticality] || 0) + 1;
        return item;
    }, {})).map(([k, v]) => ({ severity: changeSeverityKey(k), count: v })).reduce((obj, { severity, count }) => ({ ...obj, [severity]: count }), {});


    return (
            <s.Half enableBorder>
                <s.CapAssesmentResultTitle>
                    {t('CAP_ASSESSMENT_RESULT')}
                </s.CapAssesmentResultTitle>
                <s.CapAssesmentResultWrapper>
                    <s.NumberBoxWrapper>
                        <s.SubTitle>
                            {t('CAP_AREAS_FOR_IMPROVEMENT')}
                        </s.SubTitle>
                        <s.NumberBox>{findings.length}</s.NumberBox>
                    </s.NumberBoxWrapper>
                    <s.SeverityTableWrapper>
                        <s.SubTitle>
                            {t('CAP_DISTRIBUTION_SEVERITY')}
                        </s.SubTitle>
                        <s.SeverityTable>
                            <s.SeverityTableItem bg-black className='bg-black text-white'>
                                <label>{t('ZERO_TOLERANCE')}</label> <span>{severityCounts?.zero_tolerance ? severityCounts?.zero_tolerance : 0}</span>
                            </s.SeverityTableItem>
                            <s.SeverityTableItem bg-extreme className='bg-extreme text-white'>
                                <label>{t('CRITICAL')}</label> <span>{severityCounts?.critical ? severityCounts?.critical : 0}</span>
                            </s.SeverityTableItem>
                            <s.SeverityTableItem bg-high className='bg-high text-white'>
                                <label>{t('MAJOR')}</label> <span>{severityCounts?.major ? severityCounts?.major : 0}</span>
                            </s.SeverityTableItem>
                            <s.SeverityTableItem bg-medium className='bg-medium text-navy-100'>
                                <label>{t('MODERATE')}</label> <span>{severityCounts?.moderate ? severityCounts?.moderate : 0}</span>
                            </s.SeverityTableItem>
                            <s.SeverityTableItem bg-midGrey className='bg-midGrey text-navy-100'>
                                <label>{t('MINOR')}</label> <span>{severityCounts?.minor ? severityCounts?.minor : 0}</span>
                            </s.SeverityTableItem>
                        </s.SeverityTable>
                    </s.SeverityTableWrapper>
                </s.CapAssesmentResultWrapper>
            </s.Half>
    )
};

export default React.memo(CapBoxAssessmentResult);
